var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5406 11.3032L9.12104 17.8572C8.71976 18.2669 8.72265 18.932 9.12746 19.338L9.48948 19.7011C9.88926 20.1021 10.5309 20.0992 10.9272 19.6946L19.7009 10.7372C20.0997 10.33 20.0997 9.66995 19.7009 9.26282L10.9272 0.305351C10.5309 -0.0992387 9.88926 -0.102136 9.48948 0.298857L9.12746 0.661973C8.72265 1.06802 8.71976 1.73315 9.12105 2.14283L15.5406 8.69683H1.02115C0.457184 8.69683 0 9.16359 0 9.73937V10.2606C0 10.8364 0.457184 11.3032 1.02115 11.3032H15.5406Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOpen);
export default __webpack_public_path__ + "static/media/arrow_open.7860afd1735375f48dd2730180b627f4.svg";
export { ForwardRef as ReactComponent };